import { exists } from '../runtime.js';
import './ApiActivityType.js';
import './ApiAdditionalInfoType.js';
import './ApiAirportType.js';
import './ApiAvailState.js';
import './ApiBaggageType.js';
import './ApiBaggageUnitType.js';
import './ApiBaseDataSource.js';
import { ApiBaseModelFromJSONTyped, ApiBaseModelToJSON } from './ApiBaseModel.js';
import './ApiBookingAction.js';
import './ApiBookingState.js';
import './ApiCabinClass.js';
import './ApiCamperFeatureType.js';
import './ApiClientType.js';
import { ApiComponentPriceTypeFromJSON, ApiComponentPriceTypeToJSON } from './ApiComponentPriceType.js';
import { ApiComponentTypeFromJSON, ApiComponentTypeToJSON } from './ApiComponentType.js';
import './ApiConfigurationDataType.js';
import './ApiDebitType.js';
import './ApiDirection.js';
import './ApiDistanceUnit.js';
import './ApiDocumentSubType.js';
import './ApiDocumentType.js';
import './ApiDurationType.js';
import './ApiFilterCategory.js';
import './ApiFilterType.js';
import './ApiFuelType.js';
import './ApiGender.js';
import { ApiImageContainerFromJSON, ApiImageContainerToJSON } from './ApiImageContainer.js';
import './ApiImageType.js';
import './ApiInventory.js';
import { ApiItemFromJSON, ApiItemToJSON } from './ApiItem.js';
import { ApiItemTypeFromJSON, ApiItemTypeToJSON } from './ApiItemType.js';
import './ApiNoteOriginType.js';
import './ApiNoteType.js';
import './ApiPackagePriceComponentType.js';
import './ApiPaymentDataType.js';
import './ApiPaymentOption.js';
import './ApiPaymentState.js';
import './ApiPriceModifierType.js';
import './ApiPriceType.js';
import './ApiRecommendationServiceType.js';
import './ApiRelatedServiceRelationType.js';
import './ApiRole.js';
import './ApiRowCharacteristics.js';
import './ApiSeatCharacteristics.js';
import { ApiServiceSelectionTypeFromJSON, ApiServiceSelectionTypeToJSON } from './ApiServiceSelectionType.js';
import './ApiSortDirection.js';
import './ApiSortOption.js';
import './ApiSpecialRequestGroup.js';
import './ApiStaticContentType.js';
import './ApiTaxDisplay.js';
import './ApiTransmissionType.js';
import './ApiTravelStatusEnum.js';
import './ApiTravelerType.js';
import './ApiVoucherDeliveryType.js';
import './ApiWalletType.js';

/* tslint:disable */
function ApiComponentFromJSON(json) {
    return ApiComponentFromJSONTyped(json, false);
}
function ApiComponentFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...ApiBaseModelFromJSONTyped(json, ignoreDiscriminator),
        'name': json['name'],
        'shortDescription': !exists(json, 'shortDescription') ? undefined : json['shortDescription'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'startDate': (json['startDate']),
        'endDate': (json['endDate']),
        'componentType': ApiComponentTypeFromJSON(json['componentType']),
        'componentPriceType': ApiComponentPriceTypeFromJSON(json['componentPriceType']),
        'selectedItems': (json['selectedItems'].map(ApiItemFromJSON)),
        'selectableItems': (json['selectableItems'].map(ApiItemFromJSON)),
        'detailsFetched': json['detailsFetched'],
        'itemType': ApiItemTypeFromJSON(json['itemType']),
        'subItemType': ApiItemTypeFromJSON(json['subItemType']),
        'relatedComponentId': !exists(json, 'relatedComponentId') ? undefined : json['relatedComponentId'],
        'selectionType': !exists(json, 'selectionType') ? undefined : ApiServiceSelectionTypeFromJSON(json['selectionType']),
        'image': !exists(json, 'image') ? undefined : ApiImageContainerFromJSON(json['image']),
        'images': !exists(json, 'images') ? undefined : (json['images'].map(ApiImageContainerFromJSON)),
        'externalComponentId': !exists(json, 'externalComponentId') ? undefined : json['externalComponentId'],
        'displayDaily': !exists(json, 'displayDaily') ? undefined : json['displayDaily'],
        'inventories': !exists(json, 'inventories') ? undefined : json['inventories'],
    };
}
function ApiComponentToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...ApiBaseModelToJSON(value),
        'name': value.name,
        'shortDescription': value.shortDescription,
        'description': value.description,
        'startDate': (value.startDate),
        'endDate': (value.endDate),
        'componentType': ApiComponentTypeToJSON(value.componentType),
        'componentPriceType': ApiComponentPriceTypeToJSON(value.componentPriceType),
        'selectedItems': (value.selectedItems.map(ApiItemToJSON)),
        'selectableItems': (value.selectableItems.map(ApiItemToJSON)),
        'detailsFetched': value.detailsFetched,
        'itemType': ApiItemTypeToJSON(value.itemType),
        'subItemType': ApiItemTypeToJSON(value.subItemType),
        'relatedComponentId': value.relatedComponentId,
        'selectionType': ApiServiceSelectionTypeToJSON(value.selectionType),
        'image': ApiImageContainerToJSON(value.image),
        'images': value.images === undefined ? undefined : (value.images.map(ApiImageContainerToJSON)),
        'externalComponentId': value.externalComponentId,
        'displayDaily': value.displayDaily,
        'inventories': value.inventories,
    };
}

export { ApiComponentFromJSON, ApiComponentFromJSONTyped, ApiComponentToJSON };
//# sourceMappingURL=ApiComponent.js.map
